import React from 'react'
import styled, { css, keyframes } from 'styled-components'
import { color } from '../colors'

type ColorsType = {
	back: ReturnType<typeof color> | string
	line: ReturnType<typeof color> | string
	opacity: string
}

export const Shimmer: React.FC<{
	dark?: boolean
	transparent?: boolean
	className?: string
}> = ({ dark, transparent, className }) => {
	const colors: ColorsType = dark
		? {
				back: transparent ? 'transparent' : color('gray-17'),
				line: color('gray-01'),
				opacity: '0.3',
		  }
		: {
				back: transparent ? 'transparent' : color('gray-06'),
				line: color('gray-01'),
				opacity: '1',
		  }
	return (
		<Wrapper colors={colors} className={className}>
			<Line />
		</Wrapper>
	)
}

const shimmer = keyframes`
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(100vw);
  }
  `
const Line = styled.div``
const Wrapper = styled.div<{ colors: ColorsType }>`
	${({ colors }) => css`
		width: 100%;
		height: 100%;
		overflow: hidden;
		background: ${colors.back};
		filter: brightness(90%);
		position: relative;
		${Line} {
			width: 156px;
			height: 100%;
			position: absolute;
			transform: translateX(-100%);
			background: linear-gradient(
				to right,
				transparent,
				${colors.line} 38%,
				${colors.line} 62%,
				transparent
			);
			opacity: ${colors.opacity};
			animation: ${shimmer} 1.2s linear infinite;
		}
	`}
`
